import { Auth, API } from "aws-amplify";
import { IUser, INewPolicyDoc } from "@vmosolutions/oc-interfaces";

// export interface IStatement {
//   effect: string;
//   action: string[];
//   resource: string;
//   attributes: object;
// }

// export interface IPolicy {
//   _id?: any;
//   policyName: string;
//   description: string;
//   statements: IStatement[];
// }

export const getPolicies = async (): Promise<any> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  const results = await API.get("skytrains", "/permissions/policies", {
    headers: {
      Accept: "*/*",
      Authorization: token,
    },
  });
  //console.dir(results, { depth: null });
  return results;
};

export const createPolicy = async (newPolicy: INewPolicyDoc): Promise<any> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  try {
    const results = await API.post("skytrains", "/permissions/policies", {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
      body: { ...newPolicy },
    });
    //console.dir(results, { depth: null });
    return results;
  } catch (error) {
    //@ts-ignore
    return error?.response?.data;
  }
};

export const listFilteredUsers = async (partialUserEmail: string): Promise<any> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  const results = await API.get("skytrains", `/users?partialEmail=${partialUserEmail}`, {
    headers: {
      Accept: "*/*",
      Authorization: token,
    },
  });
  //console.dir(results, { depth: null });
  return results;
};

export const setUserPolicies = async (user: IUser, selectedPolicyIds: string[]): Promise<any> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  try {
    const results = await API.put("skytrains", `/permissions/policies/${user._id}`, {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
      body: {
        userId: user._id,
        selectedPolicyIds,
      },
    });
    //console.dir(results, { depth: null });
    return results;
  } catch (error) {
    // debugger;
    return null;
  }
};

export const deletePoliciesFromUser = async (userId: string, policyIds: string[]): Promise<any> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  try {
    const results = await API.del("skytrains", `/permissions/policies/${userId}`, {
      headers: {
        Accept: "*/*",
        Authorization: token,
      },
      body: {
        policyIds,
      },
    });
    //console.dir(results, { depth: null });
    return results;
  } catch (error) {
    // debugger;
    return null;
  }
};
